import { toast } from "sonner";
import { showUpgradeExternally } from "../components/UpgradePrompt";

// The Premium pop-up for a free member who pressed something that needs Premium (the heart, a second playlist,
// Recently Played, a song request...). Dan wants the full "go Premium" box to wait until the member has a playlist of
// 10 songs, so they have heard enough to see the value. Before that, the same press gets a small plain note that says
// what is locked, with no sales box.
// Two moments are NOT routed through here and always show the box: the end of a Premium song's preview clip, and the
// 11th song going into a full free playlist.
const FULL_PLAYLIST = 10;

export async function askForPremium(message, options) {
  let full = false;
  try {
    // Imported here (not at the top) so this file and api.js, which also calls it, never wait on each other.
    const { default: api } = await import("./api");
    const r = await api.get("/playlists");
    full = (r.data || []).some((p) => (p.item_count || 0) >= FULL_PLAYLIST);
  } catch { /* if the count cannot be read, stay with the quiet note */ }
  if (full) showUpgradeExternally(message, options);
  else toast(message, { id: "premium-note" });
}
